// import queryString from 'query-string';

// import AudienceIdValue from './AudienceIdValue';
import Factory from './Factory';

// const factory = Factory.create();

// console.log(queryString);


// 取得
// const parsed = queryString.parse(window.location.search);
// console.log(parsed);

// const audId = new AudienceIdValue(parsed);
// console.log(audId);
// console.log(audId.aud_id);

// export default factory;


class Module {
  constructor() {
    return Factory.create();
  }
}

export default Module;
